// extracted by mini-css-extract-plugin
export var editButton = "_nf-0";